// extracted by mini-css-extract-plugin
export var changeIcon = "_4x-4";
export var container = "_4x-0";
export var divider = "_4x-7";
export var externalLinkIcon = "_4x-1";
export var green = "_4x-5";
export var helpCircleIcon = "_4x-3";
export var iconButton = "_4x-2";
export var red = "_4x-6";